'use strict';
/**
 * Dependencies
 * @ignore
 */

var _regeneratorRuntime = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var JWA = require('./JWA');
/**
 * JWK Class
 */


var JWK = /*#__PURE__*/function () {
  function JWK() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        kty = _ref.kty,
        use = _ref.use,
        key_ops = _ref.key_ops,
        alg = _ref.alg,
        kid = _ref.kid,
        x5u = _ref.x5u,
        x5c = _ref.x5c,
        x5t = _ref.x5t;

    _classCallCheck(this, JWK);

    this.kty = kty;
    this.use = use;
    this.key_ops = key_ops;
    this.alg = alg;
    this.kid = kid;
    this.x5u = x5u;
    this.x5c = x5c;
    this.x5t = x5t;
  }
  /**
   * importKey
   *
   * TODO:
   * - should this be on JWA?
   */


  _createClass(JWK, null, [{
    key: "importKey",
    value: function () {
      var _importKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(jwk) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", JWA.importKey(jwk));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function importKey(_x) {
        return _importKey.apply(this, arguments);
      }

      return importKey;
    }()
  }]);

  return JWK;
}();
/**
 * Export
 */


module.exports = JWK;